(function () {
  // Verificar que exista la sección principal de producto
  const section = document.querySelector(".section-main-product");
  if (!section) return;

  const priceHidden = section.querySelector(".product__price__hidden");
  if (!priceHidden) return;

  // Formatea un número entero al formato CLP con separador de miles
  function formatPrice(value) {
    return (
      "$" +
      new Intl.NumberFormat("es-CL", {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value ?? 0)
    );
  }

  // Extrae el número entero desde un texto con formato "CLP 1,360,000"
  function extractNumber(text) {
    const cleaned = text.replace(/[^0-9]/g, "");
    return parseInt(cleaned, 10) || 0;
  }

  // Actualiza el precio visible si existe .expo-changed
  function updateDisplayPrice() {
    const expoChanged = priceHidden.querySelector(".expo-changed");
    if (!expoChanged) return;

    const rawText = expoChanged.textContent.trim();
    const numericValue = extractNumber(rawText);
    const formatted = formatPrice(numericValue);

    const displayEl = section.querySelector(".product__price__display");
    if (displayEl) {
      displayEl.textContent = formatted;
    }
  }

  // Ejecución inicial por si ya existe el elemento
  updateDisplayPrice();

  // Observar cambios en .product__price__hidden para detectar .expo-changed
  const observer = new MutationObserver(function () {
    updateDisplayPrice();
  });

  observer.observe(priceHidden, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
